var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoSplitCaption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "-3 -3 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C8 4.59 7.87 5.14 7.64 5.64L20 18V19H17L10 12L7.64 14.36C7.87 14.86 8 15.41 8 16C8 18.21 6.21 20 4 20C1.79 20 0 18.21 0 16C0 13.79 1.79 12 4 12C4.59 12 5.14 12.13 5.64 12.36L8 10L5.64 7.64C5.14 7.87 4.59 8 4 8C1.79 8 0 6.21 0 4C0 1.79 1.79 0 4 0C6.21 0 8 1.79 8 4ZM2 4C2 5.11 2.9 6 4 6C5.1 6 6 5.11 6 4C6 2.89 5.1 2 4 2C3.65092 2 3.32273 2.08943 3.03709 2.24664C2.42011 2.58595 2 3.24163 2 4ZM2 16C2 17.11 2.9 18 4 18C5.1 18 6 17.11 6 16C6 14.89 5.1 14 4 14C2.9 14 2 14.89 2 16ZM9.5 10C9.5 10.28 9.72 10.5 10 10.5C10.28 10.5 10.5 10.28 10.5 10C10.5 9.72 10.28 9.5 10 9.5C9.72 9.5 9.5 9.72 9.5 10ZM11 7L17 1H20V2L13 9L11 7Z",
    fill: "#7F8090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoSplitCaption);
export default __webpack_public_path__ + "static/media/Auto Split Caption.9c278ae1.svg";
export { ForwardRef as ReactComponent };